/* Host injection seam for the enterprise-local DocAgent bundle. */

import type React from 'react';

export type DocAgentModePageComponent = React.ComponentType;
export type DocAgentLandingPageComponent = React.ComponentType;
export type DocAgentEditorPageComponent = React.ComponentType<{
  itemId: string;
}>;

let modePage: DocAgentModePageComponent | null = null;
let landingPage: DocAgentLandingPageComponent | null = null;
let editorPage: DocAgentEditorPageComponent | null = null;

export function setDocAgentModePageComponent(
  component: DocAgentModePageComponent | null,
): void {
  modePage = component;
}

export function getDocAgentModePageComponent(): DocAgentModePageComponent | null {
  return modePage;
}

export function setDocAgentLandingPageComponent(
  component: DocAgentLandingPageComponent | null,
): void {
  landingPage = component;
}

export function getDocAgentLandingPageComponent(): DocAgentLandingPageComponent | null {
  return landingPage;
}

export function setDocAgentEditorPageComponent(
  component: DocAgentEditorPageComponent | null,
): void {
  editorPage = component;
}

export function getDocAgentEditorPageComponent(): DocAgentEditorPageComponent | null {
  return editorPage;
}
